import { Injectable, Output } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from "rxjs";


@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  data: Observable<any[]>;

  constructor(private firebase: AngularFireDatabase) {
  }

  getplantdata() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/2122/areas")
        // 
        .query.limitToFirst(10)
        .orderByChild("DetailPlant/ZoneId").equalTo('01.1')
        .once('value')
        .then((snapshots) => {
          let plantdata: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key,
              ...snapshot.val(),
            }
            plantdata.push(rec)
          });
          res(plantdata);
          // console.log(snapshots.val());
        }).catch((e) => {
          rej(e);
        });

    });
  }

  updategroupcode(key: any, groupcode: any) {
    const local = this.firebase.list('inst1/tx/2122/areas');
    local.update(key, { groupCode: groupcode });
  }

  updateplantdata() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/2122/areas")
        .query
        .orderByChild("DetailPlant/ZoneId")
        // .equalTo()
        .once("value")
        .then((snapshots) => {
          let plantdata: any = []
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            // if () 
            // {
            //   plantdata.push(rec)
            // }

          }))
          res(plantdata)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getRef() {
    return this.firebase;
  }

  getMaster() {
    return new Promise((resolve, reject) => {
      this.firebase
        .list("inst1/tx/2122/areas")
        // 
        .query.limitToFirst(10)
        .orderByChild("DetailPlant/ZoneId").equalTo('01.1')
        .once('value')
        .then((snapshots) => {


          console.log(snapshots.val());
        })
        .catch((e) => reject(e));
    });
  }

  getMapByYear(year: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query.limitToFirst(10)
        .once("value")
        .then((snapshots) => {
          let maps: any[] = [];
          snapshots.forEach((snapshot) => {
            maps.push({
              key: snapshot.key,
              ...snapshot.val(),
            });
          });
          // console.log(maps);
          res(maps);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  getMapByLandno(year: any, landno: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query.orderByChild("landno")
        .equalTo(landno)
        .once("value")
        .then((snapshots) => {
          let maps;
          snapshots.forEach((snapshot) => {
            maps = {
              key: snapshot.key,
              ...snapshot.val(),
            };
          });
          res(maps);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

getMapByBNMCode(year: any, code: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query.orderByChild("bnm_profile/code")
        .equalTo(code)
        .once("value")
        .then((snapshots) => {
          let maps: any[] = [];
          snapshots.forEach((snapshot) => {
            maps.push({
              key: snapshot.key,
              ...snapshot.val(),
            });
          });
          res(maps);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }


  getmapByroute(year: any, supzone: any, root: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query
        .orderByChild("DetailPlant/ZoneId")
        .equalTo(supzone)
        .once("value")
        .then((snapshots) => {
          let maps: any = []
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            // if (rec.DetailPlant.Root == root && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT') 
            if (rec.DetailPlant.Root == root && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
              maps.push(rec)
            }
          }))
          console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getmapByzone(year: any, supzone: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query
        .orderByChild("DetailPlant/ZoneId")
        .equalTo(supzone)
        .once("value")
        .then((snapshots) => {
          let maps: any = [];
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            // if (rec.DetailPlant.Root == root && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT') 
            //if ((rec.DetailPlant.Root == root) && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1)
            if (rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
              maps.push(rec)
            }
          }
          ))
          console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getmapAll(year: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query
        .orderByChild("approveSts")
        .equalTo(1)
        .once("value")
        .then((snapshots) => {
          let maps: any = [];
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            if (rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
              maps.push(rec)
            }
          }
          ))
          console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }  

  getmapAll1(year: any) {
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query
        .orderByChild("approveSts")
        .equalTo(1)
        .once('value').then(function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let rec = {
              key: childSnapshot.key
            }
            //var key = childSnapshot.key;
            //console.log(key);
            maps.push(rec);
          });
          console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getmapByitid(year: any, itid: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas/" + itid)
        .query
        .once("value")
        .then((snapshots) => {
          let maps: any = [];
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            // if (rec.DetailPlant.Root == root && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT') 
            //if ((rec.DetailPlant.Root == root) && rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1)
            //if (rec.landno != '' && rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
            maps.push(rec)
            //}
          }
          ))
          console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getplantbygroupcode(groupcode: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/2122/areas")
        .query
        .orderByChild("groupCode").equalTo(groupcode)
        .once('value')
        .then((snapshots) => {
          let plant: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key,
              ...snapshot.val(),
            }
            if (rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
              plant.push(rec)
            }

          });
          res(plant);
        }).catch((e) => {
          rej(e);
        });

    });
  }


  updateCutrunbySupporter(key: any, id: any) {
    const local = this.firebase.list('inst1/tx/2122/areas/');
    local.update(key, { cutrunning: id });
  }

  // เพิ่มวันตัดโดยนักส่งเสริม
  updateCutStartBySupport(key: any, date: any, date2: any) {
    const local = this.firebase.list('inst1/tx/2122/areas/');
    local.update(key, { cutstart: date, cutstop: date2 });
  }




  ReadPlantnobyfmcode(code: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/runLandno/")
        // 
        .query.limitToFirst(10)
        .orderByChild("code").equalTo(code)
        .once('value')
        .then((snapshots) => {
          let onefmdata: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key,
              ...snapshot.val(),
            }
            onefmdata.push(rec)
          });
          res(onefmdata);
          // console.log(snapshots.val());
        }).catch((e) => {
          rej(e);
        });

    });
  }




  // แสดงข้อมูลคนขับรถบรรทุกนอก 
  ShowTruckDriverout() {
    // เพื่มข้อมูลเข้า
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/queueRun/TruckDriverNoFmCode")
        .query
        .once("value")
        .then((snapshots) => {
          let truckdriver: any = []
          snapshots.forEach((snapshots => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }

            truckdriver.push(rec)

          }))
          res(truckdriver)
        }).catch((e) => {
          rej(e)
        })
    })
  }


  // เพิ่มข้อมูลคนขับไม่ใช่ชาวไร่ในระบบ
  ADDTruckDriverout(id: any, fullname: any) {
    const local = this.firebase.list('inst1/queueRun/TruckDriverNoFmCode');
    local.update(String(id), { code: String(id), fullname: fullname });
  }

  // ยกเลิกวันตัดเสร็จ
  Deletecutstop(key: any) {
    const local = this.firebase.list('inst1/tx/2122/areas/' + key);
    local.remove("cutstop");
  }


  getYear() {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/master/productionYear")
        .query
        .once("value")
        .then((snapshots) => {
          let year: any[] = [];
          snapshots.forEach((snapshot) => {
            year.push({
              key: snapshot.key,
              ...snapshot.val(),
            });
          });
          res(year);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  getplantbyLandno(landno: string, itid: string) {
    // let landno = "06-0000149888-0002";
    // let itid = "-Mp4fGAMr3NdrYextnu1";
    let year = localStorage.getItem('yearCr');
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query.orderByChild("landno")
        .equalTo(landno)
        .once("value")
        .then((snapshots) => {
          let maps;
          snapshots.forEach((snapshot) => {
            maps = {
              key: snapshot.key,
              ...snapshot.val(),
            };
          });
          res(maps);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  // ข้อมูลแปลงจาก firebase by itit
  getplantbyItid(itid: string) {
    let year = localStorage.getItem('yearCr');
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/tx/" + year + "/areas/" + itid)
        .query
        // .orderByChild("itid").equalTo(itid)
        .once('value')
        .then((snapshots) => {
          let plant: any[] = [];
          snapshots.forEach((snapshot) => {
            let rec = {
              key: snapshot.key,
              ...snapshot.val(),
            }
            // if (rec.DetailPlant.CaneTypeId !== 'OT' && rec.approveSts == 1) {
            //   plant.push(rec)
            // }
          });
          res(plant);
        }).catch((e) => {
          rej(e);
        });

    });
  }

  // ++++++++++++ firebase update code by KTD +++++++++++++
  // แก้ไขสถานะแปลง 1
  async updateStatusPlot(year: any, key: any, id: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/');
    local.update(key, { approveSts: id });
  }

  // ยกเลิกแปลงอ้อย
  async canclePlant(f: any) {
    console.log('f:', f);
    const local = this.firebase.list('inst1/tx/' + f.fb_year + '/areas/');
    local.update(f.fb_itid, { approveSts: 3 });
  }

  // แก้ไขประเภทอ้อย 2
  async updateCaneType(f: any) {
    const local = this.firebase.list('inst1/tx/' + f.fb_year + '/areas/' + f.fb_itid + '/');
    local.update('DetailPlant', { CaneTypeId: f.fb_edit_to, CaneTypeName: f.fb_edit_to_canename });
  }

  // แก้ไขเจ้าของแปลง 3
  async updateOwnerPlant(f: any) {
    const local = this.firebase.list('inst1/tx/' + f.fb_year + '/areas/' + f.fb_itid + '/');
    local.update('bnm_profile', { code: f.fb_edit_to, name: f.fb_edit_to_fname, surname: f.fb_edit_to_lname });
    const local2 = this.firebase.list('inst1/tx/' + f.fb_year + '/areas/');
    local2.update(f.fb_itid, { landno: f.fb_newlandno });
  }

  // ข้อมูลแปลงตาม itid on firebase work with key
  getMapByitid(year: string, itid: string) {
    return new Promise((res, rej) => {
      this.firebase
        .list('inst1/tx/' + year + '/areas/')
        .query.orderByKey()
        .equalTo(itid)
        .once('value')
        .then((snapshots) => {
          let mapdt;
          snapshots.forEach((snapshot) => {
            mapdt = {
              key: snapshot.key,
              ...snapshot.val(),
            };
          });
          res(mapdt);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }
    
}

